module.exports = __webpack_public_path__ + "img/dashboard.253c4c20.png";